import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from 'react';
import axios from 'axios';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Slide, ToastContainer } from 'react-toastify';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { LoadingOverlay } from '@achmadk/react-loading-overlay'; // Assuming this component handles the loading overlay

import RootComponent from './RootComponent';
import ProductFruitsWrapper from './components/common/ProductFruitsWrapper';
import CookieConsent from './components/common/CookieConsent';
import { useAppSelector } from './store/hooks';
import { persistor, store } from './store/store';
import { NUMBERS } from './resources/number-constants';
import { loaderStatus } from './store/features/loader';
import { setDefaultAuthToken } from './utility/helpers';
import { setupInterceptorsTo } from './utility/interceptorsAxios';

setupInterceptorsTo(axios);
if (typeof window !== 'undefined') {
    setDefaultAuthToken(axios, '');
}

const App = () => {
    const googleAuthClientId = `${process.env.REACT_APP_GOOGLE_CLIENT_ID}`;

    useEffect(() => {
        const viewportMetaTag = document.getElementById('viewport');

        if (viewportMetaTag) {
            // Always maintain mobile responsive viewport for all user types
            viewportMetaTag.setAttribute('content', 'width=device-width, initial-scale=1');
        }
    }, []);
    return (
        <GoogleOAuthProvider clientId={googleAuthClientId}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <MainContent />
                </PersistGate>
            </Provider>
        </GoogleOAuthProvider>
    );
};

const MainContent = () => {
    const isLoading = useAppSelector(loaderStatus);
    return (
        <LoadingOverlay
            active={isLoading}
            spinner
            text='Fetching...'
            styles={{
                overlay: (base) => ({
                    ...base,
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: '100vh',
                    width: '100vw',
                    zIndex: 1000,
                }),
            }}
        >
            <RootComponent />
            <ProductFruitsWrapper />
            <CookieConsent />
            <ToastContainer
                position="top-center"
                autoClose={NUMBERS.FIVE_THOUSAND}
                hideProgressBar={true}
                newestOnTop={true}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                limit={NUMBERS.ONE}
                transition={Slide}
            />
        </LoadingOverlay>
    );
};

export default App;
